import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const siyah = '#1D3343';

export default {
  primary: {
    contrastText: '#FFFFFF',
    dark: siyah,
    main: siyah,
    light: siyah
  },
  secondary: {
    contrastText: '#FFFFFF',
    dark: siyah,
    main: siyah,
    light: siyah,
    red:colors.red[900]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: siyah,
  icon: siyah,
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
